import React from 'react'
import {useDispatch} from 'react-redux'
import {
  styled,
  Checkbox as MuiCheckbox,
  FormControlLabel as MuiFormControlLabel,
} from '@material-ui/core'
import {useObjectivesState} from 'lms/hooks'
import {useCurrentSearchFilters} from 'searches/hooks'
import {updateCurrentSearchFilters} from 'searches/store/actions'

const Content = styled('fieldset')(({theme}) => ({
  margin: 0,
  marginTop: theme.spacing(1),
  borderColor: 'rgba(0, 0, 0, 0.23)',
  borderStyle: 'solid',
  borderWidth: 1,
  borderRadius: theme.shape.borderRadius,
}))

const Legend = styled('legend')(({theme}) => ({
  padding: 5,
  fontSize: 12,
  color: theme.palette.text.secondary,
}))

const Grid = styled('div')({
  display: 'flex',
  flexDirection: 'column',
})

const nameSorter = (a, b) => a.name.localeCompare(b.name)

const Objectives = (props) => {
  const {status, data} = useObjectivesState()
  const {objectives} = useCurrentSearchFilters()
  const dispatchRedux = useDispatch()

  if (status !== 'succeeded') return null

  const sortedObjectives = data.allIds
    .map(id => data.byId[id])
    .filter(o => !o.hidden)
    .sort(nameSorter)

  const toggle = (id, checked) => {
    const set = new Set(objectives)
    checked ? set.add(id) : set.delete(id)
    dispatchRedux(updateCurrentSearchFilters({objectives: Array.from(set)}))
  }

  return (
    <Content {...props}>
      <Legend>What are your learning/training objectives?</Legend>
      <Grid>
        {sortedObjectives.map((objective) => (
          <FormControlLabel
            key={objective.id}
            label={objective.name}
            control={
              <MuiCheckbox
                checked={objectives.includes(objective.id)}
                onChange={(e, checked) => toggle(objective.id, checked)}
              />
            }
          />
        ))}
      </Grid>
    </Content>
  )
}

const FormControlLabel = styled(MuiFormControlLabel)({})

export default Objectives
